import React, { useCallback, useMemo } from "react";
import { useField } from "formik";
import { TransactionRuleActionFormSchema } from "../constants";
import { ClassFilter } from "../../../../Class/ClassFilter/ClassFilter";

interface Props {
    index: number;
}

export const ClassActionForm: React.FC<Props> = ({ index }) => {
    const [field, , helpers] = useField<
        TransactionRuleActionFormSchema["value"]
    >(`actions.${index}.value`);

    // Initialize with empty array if undefined
    const selectedClasses = useMemo(
        () => field.value?.classIds ?? [],
        [field.value?.classIds],
    );

    const handleClassesSelected = useCallback(
        (classIds: string[]) => {
            helpers.setValue({ classIds });
        },
        [helpers],
    );

    return (
        <ClassFilter
            selectedClasses={selectedClasses}
            onChange={handleClassesSelected}
            showFilterTypeSettings={false}
            disabled={false}
            behaviour={{
                selectedParentClassIncludesAllChildren: true,
                canSelectOnlyOneClassInTheSameRoot: false,
                bottomButtonIsAlwaysVisible: true,
            }}
        />
    );
};
